<template>
    <div class="campaign-card" @click="clickCampaign()">
        <div class="campaign-card-img">
            <img :src="campaign.fullImageUrl"/>
            <div v-if="campaign.qty == 0">
                <div class="bg-campaign-sold-out"></div>
                <div class="campaign-sold-out">
                    <div class="sold-out">
                        <div class="text-sold-out">Sold out</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="discount" v-if="campaign.discount > 0">
            <div class="discount-img">
                <img src="@/assets/new/bg/bg-discount.png"/>
                <div class="discount-text">
                    <div class="text">ลด</div>
                    <div class="text">{{ getDiscount() }}%</div>
                </div>
            </div>
        </div>
        <div class="campaign-card-info">
            <div class="campaing-name">{{campaign.name}}</div>
            <div class="campaing-flashsale-gauge">
                <div class="flashsale-gauge">
                    <div class="gauge-progress" :style="gaugeStyle"></div>
                    <div class="gauge-txt font-10">{{getItemCountSold()}}</div>
                </div>
            </div>
            <div class="price-card">
                <div class="price-info">
                    <div class="price-unit">{{getUnit()}}</div>
                    <div class="original-price" v-if="blobConfig.app_redeem_type != 'point'">{{getOriginalPrice()}}</div>
                </div>
                <div class="add-card">
                    <img v-if="campaign.qty != 0" src="../../../assets/new/icon/ic-add-card-active.png"/>
                    <img v-else src="../../../assets/new/icon/ic-add-card-inactive.png"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js"
import Util from "@/helper/Utility";

export default {
    name: 'FlashSaleItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign,
            gaugeStyle: {
                width: '0%',
                backgroundColor: "#f8a51b"
            },
        };
    },
    created: function() {
        this.blobConfig = Account.getCacheBlob("BlobConfig")
    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            var path = '/flashsale/campaign/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },
        getPercentage: function () {
            return (this.campaign.itemCountSold / (this.campaign.itemCountSold + this.campaign.qty)) * 100;
        },
        getItemCountSold: function () {
            this.percentageQTY = this.getPercentage();
            this.gaugeStyle.width = this.percentageQTY.toString() + '%';
            return Util.stringFormat(this.lbl.B2B.flashsale.item_count_sold,Util.formatNum(Number(this.campaign.itemCountSold)));
        },
        getUnit: function() {
            if (this.blobConfig.app_redeem_type == "point") {
                return Util.stringFormat(this.lbl.B2B.campaign.point,Util.formatNum(Number(this.campaign.pointPerUnit)));
            } else {
                return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.pricePerUnit)));
            }
        },
        getOriginalPrice: function () {
            return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.originalPrice)));
        },
        // clickAddToCart: function () {
        //     var item = {
        //         campaignId: this.campaign.id,
        //         qty: 1
        //     }
        //     this.$emit('clickAddToCart', item)
        // }
        getDiscount: function() {
            return Util.formatNum(this.campaign.discount)
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import "@/style/base/baseImage.scss";
    @import "@/style/base/baseText.scss";
    @import "./flashsaleitem.scss";

    .discount {
            position: absolute;
            top: 0px;
            right: 0px;
            .discount-img{
                position: relative;
                img {
                    width: 100%;
                    max-width: 30px;
                    height: auto;
                }
            }
            .discount-text {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                display: grid;
                grid-column: 1;
                font-size: $px10;
                color: white;
                .text {
                    display: flex;
                    justify-content: center;
                }
            }
    }
</style>
